import { HomePage } from "../pages/StarterPage/index";
import SigninLandingPage from "../pages/SigninLandingPage";
import NewLogin from "../pages/Authentication/NewLogin/NewLogin";
import ResetPassword from "../pages/Authentication/NewLogin/ResetPassword";
import VerifyEmail from "../pages/Authentication/VerifyEmail/VerifyEmail";
import EmailVerificationPending from "../pages/Authentication/EmailVerificationPending/EmailVerificationPending";
import { WEB_LOGIN_PATH } from "./authPaths";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const publicRoutes: Array<RouteProps> = [
  { path: "/", component: <HomePage /> },
  { path: "/chat", component: <HomePage /> },
  { path: "/signin", component: <SigninLandingPage /> },
  { path: WEB_LOGIN_PATH, component: <NewLogin /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/verify-email", component: <VerifyEmail /> },
  { path: "/verification-pending", component: <EmailVerificationPending /> },
];

export { publicRoutes };
